import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Slide from '@material-ui/core/Slide';
import { Icon, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { SettingMenu } from '../../../feature/setting/components/setting-menu';
import useIslogin from '../../Hook/useIslogin';

const useStyles = makeStyles((theme) => ({
  mizbanBrand: {
    textDecoration: 'none',
    color: '#fff',
    fontWeight: 500,
    marginLeft: 6,
  },
  menuButton: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  appBarBtn: {
    color: theme.bg.tertiary,
  },
  box: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  mizbanIcon: {
    borderRadius: '50%',
    backgroundColor: '#fff',
    fontSize: 35,
  },
  container: {
    display: 'flex',
    maxWidth: 1032,
    alignItems: 'center',
  },
}));

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger(window);

  return (
    <Slide appear={false} direction='down' in={!trigger}>
      {children}
    </Slide>
  );
}

export const AppNavbar = ({ children }) => {
  const classes = useStyles();
  useIslogin();

  return (
    <>
      <CssBaseline />
      <HideOnScroll {...children}>
        <AppBar className={classes.appBar}>
          <Toolbar variant='dense'>
            <Container className={classes.container}>
              <Box className={classes.box}>
                <Icon
                  className={classes.mizbanIcon}
                  component={Link}
                  to='/meetings'
                >
                  <img
                    src={process.env.PUBLIC_URL + '/icons/mizban.svg'}
                    alt='mizban'
                    height='100%'
                    width='100%'
                  />
                </Icon>
                <Link to='/meetings' className={classes.mizbanBrand}>
                  Mizban
                </Link>
              </Box>

              <SettingMenu />
            </Container>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
      <Container style={{ marginTop: 16 }}>{children}</Container>
    </>
  );
};
